export default "__VITE_ASSET__BhW_dXMi__"